import {useEffect} from 'react';
import {FieldValues} from 'react-hook-form';
import Title from '@/components/help/common/Title';
import ObjectionNotice from '@/components/help/pc/objection/ObjectionNotice';
import {FormGroup} from '@/components/help/common/FormContainer';
import {useFormDefaultFieldValues} from '@/hooks/help/useFormDefaultValues';
import {useSubmitForm} from '@/hooks/help/useSubmitForm';
import {
  FORM_TYPE_OBJECTION,
  OBJECTION_FIELD_ORDER,
} from '@/constants/help/index';
import {useGetObjectionStatus} from '@/hooks/help/useGetObjectionStatus';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import useObjectionErrorHandler from '@/hooks/help/useObjectionErrorHandler';

// 이의신청 페이지
const HelpObjection = () => {
  const {setUserId} = useHelpContext();
  const {data: objectionUserData, isError, error} = useGetObjectionStatus();

  useObjectionErrorHandler(isError, error);

  const defaultFieldValues = useFormDefaultFieldValues({
    type: FORM_TYPE_OBJECTION,
  });
  const {mutate: postHelpForm} = useSubmitForm({type: FORM_TYPE_OBJECTION});

  const onSubmit = (data: FieldValues) => {
    postHelpForm(data);
  };

  useEffect(() => {
    if (objectionUserData) {
      setUserId(objectionUserData.userId);
    }
  }, [objectionUserData, setUserId]);

  return (
    <>
      <Title title='이의신청' />
      <ObjectionNotice />
      <FormGroup
        onSubmit={onSubmit}
        fieldOrder={OBJECTION_FIELD_ORDER}
        defaultValues={defaultFieldValues}
        type={FORM_TYPE_OBJECTION}>
        <FormGroup.UserId />
        <FormGroup.Email />
        <FormGroup.Title />
        <FormGroup.Content />
        <FormGroup.AttachedFiles />
        <FormGroup.CautionBox />
        <FormGroup.Agreement />
        <FormGroup.ActionButtons />
      </FormGroup>
    </>
  );
};

export default HelpObjection;
